const ITEMS = [
  "शुद्ध अनाज",
  "Fresh Atta & Rice",
  "Spices & Masalas",
  "Cold-Pressed Oils",
  "देसी घी",
  "Snacks & Namkeen",
  "Home Delivery Available",
  "पूजा सामग्री",
  "30+ Years of Trust",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic text-lg md:text-xl text-cream/90 px-6 whitespace-nowrap">{item}</span>
        <span className="text-gold text-xs">✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-forest py-4 overflow-hidden border-y border-[#3E6152]">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
